import { Container, type ContainerInfoObject, Plugins } from '@getgo/container-client'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let containerInfo: ContainerInfoObject | undefined

export const initializeContainerInfo = async () => {
  if (Container.isPluginAvailable('ContainerInfo')) {
    const info = await Plugins.ContainerInfo.getInfo()
    containerInfo = info
  }
}

export const getContainerInfo = () => containerInfo
